import { StoreModule } from '@ngrx/store';
import { ApprovesFeatureKey } from './approves-feature-key';
import { approvesReducer } from './approves.reducer';

export * from './approves-feature-key';
export * from './approves.actions';
export * from './approves.effects';
export * from './approves.reducer';
export * from './approves.selectors';

export const ApprovesStoreModule = StoreModule.forFeature(
  ApprovesFeatureKey,
  approvesReducer
);
